"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupInfo = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
/**
 *  GET /v2/chat/groups/:chatId
 */
// TODO: Currently this is not exported from the SDK
const getGroupInfo = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { chatId, env = constants_1.default.ENV.PROD } = options || {};
    try {
        if (chatId == null || chatId.length == 0) {
            throw new Error(`chatId cannot be null or empty`);
        }
        const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
        const requestUrl = `${API_BASE_URL}/v2/chat/groups/${chatId}`;
        return axios_1.default
            .get(requestUrl)
            .then((response) => {
            return response.data;
        })
            .catch((err) => {
            var _a, _b;
            if ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data)
                throw new Error((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data);
            throw new Error(err);
        });
    }
    catch (err) {
        console.error(`[Push SDK] - API  - Error - API ${exports.getGroupInfo.name} -:  `, err);
        throw Error(`[Push SDK] - API  - Error - API ${exports.getGroupInfo.name} -: ${err}`);
    }
});
exports.getGroupInfo = getGroupInfo;
//# sourceMappingURL=getGroupInfo.js.map